import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";
import { CONVERSATIONS } from "@/constants/testIds";

// Fix AS (2026-10-27): el equipo arma desde el chat el link de reserva (el mismo que manda el agente): la persona
// elige dia y horario en la pagina, con el tratamiento y sus datos ya cargados. El texto se agrega a la caja de
// respuesta para que lo revise y lo mande ella.
export default function BookingLinkDialog({ open, onOpenChange, conversationId, onInsert }) {
  const [services, setServices] = useState([]);
  const [serviceId, setServiceId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return undefined;
    let alive = true;
    setServiceId("");
    setError("");
    api.get("/services")
      .then(({ data }) => { if (alive) setServices((data || []).filter((s) => s.is_active !== false)); })
      .catch(() => { if (alive) setError("No se pudo cargar la lista de tratamientos."); });
    return () => { alive = false; };
  }, [open]);

  const handleInsert = async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post(`/conversations/${conversationId}/booking-link`, { service_id: serviceId || null });
      onInsert(data.text);
      onOpenChange(false);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "No se pudo armar el link.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid={CONVERSATIONS.bookingLinkDialog}>
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Link de reserva</DialogTitle>
          <DialogDescription>
            La persona elige día y horario en la página de reservas, con sus datos ya cargados. El link sirve una sola vez y vence a los 7 días.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2 py-2">
          <Label className="text-sm text-muted-foreground block">Tratamiento</Label>
          <select
            className="w-full h-10 rounded-md border border-input bg-background px-3 text-sm"
            value={serviceId}
            onChange={(e) => setServiceId(e.target.value)}
            data-testid={CONVERSATIONS.bookingLinkService}
          >
            <option value="">Que lo elija en la página</option>
            {services.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
          {error && <p className="text-sm text-destructive" data-testid={CONVERSATIONS.bookingLinkError}>{error}</p>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={handleInsert} disabled={loading} className="bg-brand hover:bg-brand-hover text-white" data-testid={CONVERSATIONS.bookingLinkInsertButton}>
            {loading ? "Armando..." : "Agregar al mensaje"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
